export const blogInitialState = {
  artigos: [],
  artigoSelecionado: {},
};
